
import React, { useEffect } from 'react';
import { Header } from "@/components/Header";
import { FooterSection } from "@/components/FooterSection";
import ComplianceContent from "@/components/expertise/ComplianceContent";

const Compliance = () => {
  useEffect(() => {
    document.title = "AI Regulatory Compliance Solutions | DocketLabs";
    
    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'AI regulatory compliance solutions for law firms. Automated monitoring, risk assessment & reporting. Stay compliant with AI.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'AI regulatory compliance solutions for law firms. Automated monitoring, risk assessment & reporting. Stay compliant with AI.';
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }, []);

  return (
    <>
      <Header />
      <div className="pt-24 bg-background min-h-screen">
        <ComplianceContent />
      </div>
      <FooterSection />
    </>
  );
};

export default Compliance;
